import type { ExploreContentItemContentOneOfAuth } from './exploreContentItemContentOneOfAuth';
import type { ExploreContentItemContentOneOfAuthor } from './exploreContentItemContentOneOfAuthor';
import type { ExploreContentItemContentOneOfBasicInfo } from './exploreContentItemContentOneOfBasicInfo';
import type { ExploreContentItemContentOneOfEngagement } from './exploreContentItemContentOneOfEngagement';
import type { ExploreContentItemContentOneOfMedia } from './exploreContentItemContentOneOfMedia';
import type { ExploreContentItemContentOneOfPoll } from './exploreContentItemContentOneOfPoll';
import type { ExploreContentItemContentOneOfReferencedTweet } from './exploreContentItemContentOneOfReferencedTweet';
import type { ExploreContentItemContentOneOfTags } from './exploreContentItemContentOneOfTags';
import type { ExploreContentItemContentOneOfUserInteraction } from './exploreContentItemContentOneOfUserInteraction';

export type ExploreContentItemContentOneOf = {
  /** 인증 컨텍스트 정보 */
  auth?: ExploreContentItemContentOneOfAuth;
  /** 트윗 작성자 정보 */
  author?: ExploreContentItemContentOneOfAuthor;
  basicInfo?: ExploreContentItemContentOneOfBasicInfo;
  engagement?: ExploreContentItemContentOneOfEngagement;
  /** 미디어 정보 */
  media?: ExploreContentItemContentOneOfMedia;
  /** 트윗에 포함될 투표 정보 (선택 사항) */
  poll?: ExploreContentItemContentOneOfPoll;
  /** 참조된 트윗 정보 (답글, 인용, 리트윗인 경우) */
  referencedTweet?: ExploreContentItemContentOneOfReferencedTweet;
  /** 트윗 태그 정보 */
  tags?: ExploreContentItemContentOneOfTags;
  /** 사용자 상호작용 정보 */
  userInteraction?: ExploreContentItemContentOneOfUserInteraction;
};
